import { api_react_v1_create_session_path, api_react_v1_login_by_email_path } from '@routes';

import request from './request';

export interface LoginByEmailParams {
  email: string;
  returningUrl?: string;
}

export interface CreateSessionParams {
  email: string;
  password: string;
  returningUrl?: string;
}

export interface LoginByEmailResponse {
  email: string;
  redirectUrl?: string;
  render?: string;
  returningUrl?: string;
}

export interface CreateSessionResponse {
  success: boolean;
  returningUrl?: string;
  error?: Error;
}

export async function loginByEmail(params: LoginByEmailParams): Promise<LoginByEmailResponse> {
  const resp = await request(
    'post',
    api_react_v1_login_by_email_path({
      email: params.email,
      returning_url: params.returningUrl,
    })
  );
  return resp;
}

export async function createSession(params: CreateSessionParams): Promise<CreateSessionResponse> {
  const resp = await request(
    'post',
    api_react_v1_create_session_path({
      email: params.email,
      password: params.password,
      returning_url: params.returningUrl,
    })
  );
  return resp;
}
